import { Header } from '../Layouts/Header';
import '../../styles/homepage.css';
import Watch from '../svgs/Watch';
import appScreenshot from '../../assets/imgs/app-screenshot.svg';
import orderComplete from '../../assets/imgs/order-complete.svg';
import CallToActionButton from '../Layouts/CallToActionButton';
import ChevriDir from '../svgs/ChevriDir';
import { useEffect, useState } from 'react';
import Money from '../svgs/Money';
import PriceTag from '../svgs/PriceTag';
import Footer from '../Layouts/Footer';

export const HomePage = () => {
  const [count, setCount] = useState(0);
  const [prices, setPrices] = useState({ lux: 400, pre: 200 });

  const slideElement = (count2, sliders) => {
    const sliderButtons = document.querySelectorAll(
      '.slider-lower-buttons > div'
    );
    setCount(count2);

    sliders.forEach((slider) => {
      if (sliders[count2] !== slider) {
        slider.style.display = 'none';
      }
    });

    sliderButtons.forEach((button) => {
      if (sliderButtons[count2] !== button) {
        button.classList.remove('active');
      }
    });

    sliders[count2].style.display = 'block';
    sliderButtons[count2].classList.add('active');
  };

  const slideRight = () => {
    const sliders = document.querySelectorAll('.slider-content');
    if (count >= sliders.length - 1) {
      slideElement(0, sliders);
    } else {
      slideElement(count + 1, sliders);
    }
  };

  const slideLeft = () => {
    const sliders = document.querySelectorAll('.slider-content');
    if (count <= 0) {
      slideElement(sliders.length - 1, sliders);
    } else {
      slideElement(count - 1, sliders);
    }
  };

  const slideTo = (destination) => {
    const sliders = document.querySelectorAll('.slider-content');
    slideElement(destination, sliders);
  };

  useEffect(() => {
    const t = setInterval(slideRight, 2000);

    return () => clearInterval(t);
    // eslint-disable-next-line
  }, [count]);

  // fetch current car prices
  useEffect(() => {
    let mounted = true;
    (async () => {
      if (mounted) {
        const luxPrice = await getCarPrice('luxury');
        if (luxPrice.err) {
          setPrices((prev) => ({ ...prev, lux: 400 }));
        } else {
          setPrices((prev) => ({ ...prev, lux: luxPrice }));
        }

        const prePrice = await getCarPrice('premium');
        if (prePrice.err) {
          setPrices((prev) => ({ ...prev, pre: 400 }));
        } else {
          setPrices((prev) => ({ ...prev, pre: prePrice }));
        }
      }
    })();

    return () => (mounted = false);

    // eslint-disable-next-line
  }, []);

  const getCarPrice = async (car) => {
    try {
      const res = await fetch(
        `https://liontaxi-api.emmalion.com/api/prices/${car}`
      );
      const jsonRes = await res.json();

      if (res.ok) {
        return jsonRes.msg;
      } else {
        return {
          err: true,
        };
      }
    } catch (err) {
      return {
        err: true,
      };
    }
  };

  const locations = ['Ekpoma', 'Benin'];

  return (
    <div className='home-container'>
      <header className='header-container'>
        <Header />
        <div className='hero-container'>
          <div className='intro'>
            <h1>
              <span>Let’s get you to your destination in no time</span>
              <Watch />
            </h1>
            <h3>Enjoy Luxury ride Anytime</h3>
            <div className='store-buttons'>
              <CallToActionButton store={true} />
            </div>
          </div>
          <div className='svg-content'>
            <img
              src={appScreenshot}
              width={500}
              height={478}
              alt='app screenshot'
            />
          </div>
        </div>
      </header>
      <main className='home-main'>
        <div className='luxury-first'>
          <img
            src='https://images.unsplash.com/photo-1566753323558-f4e0952af115?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=721&q=80'
            alt='luxury car'
            width={500}
          />

          <div className='desc'>
            <h2>Luxury First</h2>
            <p>
              Lorem ipsum dolor sit amet, consectetur adipisicing elit. Possimus
              eligendi consequuntur similique tenetur maxime ut quibusdam omnis
              aliquid repellat repudiandae? Atque porro, expedita dicta iusto
              impedit voluptatum. Modi eius dignissimos fugiat, sunt velit
              tempore nobis error natus praesentium impedit veritatis.
            </p>
            <CallToActionButton title='Get Started' />
          </div>
        </div>
        <div className='slider-con'>
          <div className='slider-content' />
          <div className='slider-content' />
          <div className='slider-content' />
          <div className='slider-buttons'>
            <ChevriDir onClick={slideLeft} />
            <ChevriDir onClick={slideRight} />
          </div>
          <div className='slider-lower-buttons'>
            <div onClick={() => slideTo(0)} />
            <div onClick={() => slideTo(1)} />
            <div onClick={() => slideTo(2)} />
          </div>
        </div>
        <div className='order-con'>
          <img src={orderComplete} alt='order complete svg' width={650} />
          <div className='desc'>
            <h2>Book your ride in seconds</h2>
            <CallToActionButton title="Let's go" />
          </div>
        </div>
        <div className='price-con'>
          <Money />
          <div className='desc'>
            <h2>Unbeatable Price List for Everyone</h2>
            <p>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit ut
              aliquam, purus sit amet luctus venenatis, lectus magna fringilla
              urna, porttitor rhoncus dolor purus non enim
            </p>
          </div>
          <div className='price-list-con'>
            <div className='price'>
              <PriceTag fill={'#B49714'} />
              <span>Luxury</span>
              <span>&#8358;{prices.lux}/m</span>
            </div>
            <div className='price'>
              <PriceTag />
              <span>Premium</span>
              <span>&#8358;{prices.pre}/m</span>
            </div>
          </div>
        </div>
        <div className='locations-con'>
          <h2>Where we operate</h2>
          <div className='locations-slider'>
            {locations.map((location, index) => (
              <h3 key={index}>{location}</h3>
            ))}
          </div>
          <CallToActionButton title='Get Started' />
        </div>
      </main>
      <Footer />
    </div>
  );
};

// https://images.unsplash.com/photo-1629820408206-e9fc918abf63?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=786&q=80
